<template>
  <div v-frag>
    <base-navigator-drawer />
    <base-top-navigator-bar />
    <v-main>
      <slot />
      <top-gainer-section />
        <section class="agents">
          <v-row>
            <v-col
              cols="3"
              md="1"
              v-for="(studio, index) in [
                'ag.png',
                'betsoft.png',
                'bg.png',
                'blueprint.png',
                'dream_gamming.png',
                'evoplay.png',
                'funky_play.png',
                'gamatron.png',
                'gameplay.png',
                'gdg.png',
                'gg_fishing.png',
                'green_dragon.png',
                'habanero.png',
                'iron_dog.png',
                'joker.png',
                'kalamba.png',
                'maverick.png',
                'microgaming.png',
                'n2.png',
                'pg.png',
                'playstart.png',
                'pragmatic.png',
                'quickspin.png',
                'red_tiger.png',
                'relax_gaming.png',
                'sa.png',
                'sexy_gaming.png',
                'simpleplay.png',
                'toptrend.png',
                'wm.png',
                'yggdrasil.png',
              ]"
              :key="index"
            >
              <img width="100%" :src="require(`@/assets/studio_logos/${studio}`)" alt="">
            </v-col>
          </v-row>
        </section>
      <base-footer />
      <base-footer-navigator
        v-show="$vuetify.breakpoint.mdAndDown"
      />
    </v-main>
    <dialog-connector>
      <template v-slot:default="{ possibleDialog }">
        <dialog-connector>
          <template
            v-for="dialog in possibleDialog"
            v-slot:[dialog]="{ open, closeDialog, dialogType, dialogData }"
          >
            <component
              v-if="dialogType === dialog"
              :key="dialog"
              :is="dialog"
              :open="open"
              :dialogData="dialogData"
              @close-dialog="closeDialog()"
            />
          </template>
        </dialog-connector>
      </template>
    </dialog-connector>
    <base-snackbar />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import BaseTopNavigatorBar from '@/components/BaseTopNavigatorBar.vue';
import BaseNavigatorDrawer from '@/components/BaseNavigatorDrawer.vue';
import BaseFooter from '@/components/BaseFooter.vue';
import TopGainerSection from '@/components/TopGainerSection.vue';
import BaseFooterNavigator from '@/components/BaseFooterNavigator.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import RegisterDialog from '@/components/RegisterDialog.vue';
import DialogConnector from '@/connector/Dialog.vue';
import DepositDialog from '@/components/DepositDialog.vue';
import ManualDepositDialog from '@/components/ManualDepositDialog.vue';
import WithdrawDialog from '@/components/WithdrawDialog.vue';
import TransactionDialog from '@/components/TransactionDialog.vue';
import BaseSnackbar from '@/components/BaseSnackbar.vue';
import ProfileDialog from '@/components/ProfileDialog.vue';
import TopgameDialog from '@/components/TopgameDialog.vue';
import PromotionDialog from '@/components/PromotionDialog.vue';
import FortuneWheelDialog from '@/components/FortuneWheelDialog.vue';
import AffiliateDialog from '@/components/AffiliateDialog.vue';
import RefundLossDialog from '@/components/RefundLossDialog.vue';
import GiveawayDialog from '@/components/GiveawayDialog.vue';
import QrcodeGenerateDialog from '@/components/QrcodeGenerateDialog.vue';
import ContactDialog from '@/components/ContactDialog.vue';
import NotifyPromotionDialog from '@/components/NotifyPromotionDialog.vue';

@Component({
  components: {
    BaseTopNavigatorBar,
    BaseNavigatorDrawer,
    BaseFooter,
    TopGainerSection,
    BaseFooterNavigator,
    DialogConnector,
    LoginDialog,
    RegisterDialog,
    DepositDialog,
    ManualDepositDialog,
    WithdrawDialog,
    TransactionDialog,
    BaseSnackbar,
    ProfileDialog,
    TopgameDialog,
    PromotionDialog,
    FortuneWheelDialog,
    AffiliateDialog,
    RefundLossDialog,
    GiveawayDialog,
    QrcodeGenerateDialog,
    ContactDialog,
    NotifyPromotionDialog,
  },
})
export default class DefaultLayout extends Vue {

}
</script>

<style>

</style>
